import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {DataService} from '../../services/data.service';

@Injectable()
export class SsoService extends DataService {
    constructor(http: HttpClient) {
    	super(http);
    }

    private baseURI = this.apiUri + '/sso';

    initiateSSO(): Observable<any>  {
        return this.http.get(this.baseURI + '/sso-login', {responseType: 'text'});
    }

    getHostDetails(): Observable<any>  {
        return this.http.get('../tmssserver/api/public/host');
    }
}
